import instance from '../utils/axios';

class EquipmentService {
    async repairingInfo(pageIndex, keyword,equipmentId) {
        return await instance.post('/crm/crm/projectEquipment/getEquipmentRepairingInfo?equipmentId='+equipmentId, {
            pageSize: 10,
            pageIndex: pageIndex,
            dictionaryNames: 'creatorId.base_staff,creatorId.base_staff.avatar,customerId.crm_customer,firstExaminerId.base_staff.avatar',
            expressions: '[{"field": "数量", "expression": "count(1)"}]',
            fuzzySearch: keyword,
            sortField: 'createTime',
            sort: 'desc'
        });
    }

    async maintenanceInfo(pageIndex, keyword,equipmentId,projectId) {
        return await instance.post('/crm/crm/projectEquipment/getEquipmentMaintenanceInfo?equipmentId='+equipmentId+"&projectId="+projectId, {
            pageSize: 10,
            pageIndex: pageIndex,
            dictionaryNames: 'creatorId.base_staff,creatorId.base_staff.avatar,customerId.crm_customer,firstExaminerId.base_staff.avatar',
            expressions: '[{"field": "数量", "expression": "count(1)"}]',
            fuzzySearch: keyword,
            sortField: 'createTime',
            sort: 'desc'
        });
    }

    async partsList(pageIndex, keyword,equipmentId) {
        return await instance.post('/crm/crm/projectEquipment/getPartsList?equipmentId='+equipmentId, {
            pageSize: 10,
            pageIndex: pageIndex,
            dictionaryNames: '',
            expressions: '[{"field": "数量", "expression": "count(1)"}]',
            fuzzySearch: keyword,
            sortField: 'designedLife',
            sort: 'asc'
        });
    }

    async getPayAmountInfo(pageIndex, keyword,equipmentId) {
        return await instance.post('/crm/crm/projectEquipment/getCollectionInfo?equipmentId='+equipmentId, {
            pageSize: 10,
            pageIndex: pageIndex,
            dictionaryNames: 'advisorId.base_staff,advisorId.base_staff.avatar,paymentType.dict_receipt_payment_type',
            expressions: '[{"field": "数量", "expression": "count(1)"}]',
            fuzzySearch: keyword,
            sortField: 'createTime',
            sort: 'desc'
        });
    }

    async getEquipment(equipmentId) {
        return await instance.post('/crm/crm/projectEquipment/getEquipmentById?equipmentId='+equipmentId);
    }
}
export default new EquipmentService();